const SMALL_PAGE_SIZE = 15;
const MEDIUM_PAGE_SIZE = 30;
const LARGE_PAGE_SIZE = 50;

export const defaultPageSizes: number[] = [
    SMALL_PAGE_SIZE,
    MEDIUM_PAGE_SIZE,
    LARGE_PAGE_SIZE
];